import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/57805935-e6fd7e00-7712-11e9-873a-98187da7a06c.png",
        "alt": "Octicons"
      }}></img></p>
    <h2>{`Octicons`}</h2>
    <p>{`Octicons are the standard icon set used on GitHub.`}</p>
    <h3>{`Formats available`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://octicons.github.com/"
        }}>{`Web`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/primer/octicons"
        }}>{`GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/1ljgTFkT5NKNRfq5hw07JQ/Octicons"
        }}>{`Figma`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://drive.google.com/open?id=1SgEAakP98krI0TxzXc_B0AAGu4AxI2G5"
        }}>{`Keynote`}</a></li>
    </ul>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/57806011-13b19580-7713-11e9-8e27-7d481b5314cc.png",
        "alt": "GitHub Marketing icons"
      }}></img></p>
    <h2>{`GitHub Marketing icons`}</h2>
    <p>{`The GitHub Marketing icons were created by the Creative team for use in our web, email, and other digital marketing collateral. Choose from GitHub's brand blue color, or a monochrome white on dark.`}</p>
    <h3>{`Formats available`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://ghicons.github.com/"
        }}>{`Web`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/github/icons"
        }}>{`GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/mI7o0RNCbWFhckw2svxKsm/GitHub-Updated-icons-Expanded?node-id=56%3A56"
        }}>{`Figma`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://drive.google.com/open?id=1SgEAakP98krI0TxzXc_B0AAGu4AxI2G5"
        }}>{`Keynote & PowerPoint`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      